import { createFileRoute } from "@tanstack/react-router";
import { CursosSector } from "@/components/cursos-sector";

const TITLE = "Cursos para Empresas Mineras | Capacitación Empresas | Mine Class";
const DESCRIPTION =
  "Cursos online para compañías y contratistas de la minería: normativa y Decreto 44, seguridad operacional, procesos mineros y campus virtual corporativo.";

export const Route = createFileRoute("/cursos/empresas/mineria")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "https://mine-class.com/cursos/empresas/mineria" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/cursos/empresas/mineria" }],
  }),
  component: () => <CursosSector sector="mineria" />,
});
